import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-adcae974"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "lab-env__compact-head"
}
const _hoisted_2 = { class: "lab-env__grow" }
const _hoisted_3 = {
  key: 0,
  class: "lab-env__status lab-env__status--live"
}
const _hoisted_4 = {
  key: 2,
  class: "lab-env__status"
}
const _hoisted_5 = { class: "lab-env__mono" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_8 = {
  key: 1,
  class: "lab-env__head"
}
const _hoisted_9 = {
  key: 0,
  class: "lab-env__status lab-env__status--live"
}
const _hoisted_10 = {
  key: 1,
  class: "lab-env__status"
}
const _hoisted_11 = {
  key: 2,
  class: "lab-env__empty"
}
const _hoisted_12 = { class: "lab-env__empty-icon" }
const _hoisted_13 = {
  key: 3,
  class: "lab-env__empty"
}
const _hoisted_14 = { class: "lab-env__empty-icon" }
const _hoisted_15 = { class: "lab-env__mono" }
const _hoisted_16 = {
  key: 4,
  class: "lab-env__empty"
}
const _hoisted_17 = { class: "lab-env__empty-icon" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_20 = {
  key: 5,
  class: "lab-env__body"
}
const _hoisted_21 = { class: "lab-env__grid" }
const _hoisted_22 = { class: "lab-env__box" }
const _hoisted_23 = { class: "lab-env__grow" }
const _hoisted_24 = { class: "lab-env__label" }
const _hoisted_25 = { class: "lab-env__mono lab-env__value" }
const _hoisted_26 = ["title"]
const _hoisted_27 = { class: "lab-env__box" }
const _hoisted_28 = { class: "lab-env__grow" }
const _hoisted_29 = { class: "lab-env__label" }
const _hoisted_30 = { class: "lab-env__mono lab-env__value" }
const _hoisted_31 = ["title", "disabled"]
const _hoisted_32 = /*#__PURE__*/_createTextVNode("1h ")
const _hoisted_33 = {
  key: 0,
  class: "lab-env__done"
}
const _hoisted_34 = { class: "lab-env__input" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_37 = { class: "lab-env__foot" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}

import { computed, toRef } from 'vue';
import HcIcon from '@/modern/components/ui/HcIcon.vue';
import { useLearningPathI18n } from '../view/learningPath';
import { useLabInstance } from './useLabInstance';
import type { LabKind } from './labs';


export default /*#__PURE__*/_defineComponent({
  props: {
    kind: null,
    resource: null,
    pathwayId: { default: undefined },
    compact: { type: Boolean, default: false }
  },
  emits: ["flag-accepted"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'flag-accepted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { kind: LabKind, resource: any, pathwayId: string, compact: boolean }





const { tl } = useLearningPathI18n();

const {
  tg,
  tk,
  loading,
  submitting,
  flag,
  countdown,
  releaseCountdown,
  copied,
  canStart,
  instance,
  isActive,
  start,
  stop,
  addTime,
  submitFlag,
  copyIp,
} = useLabInstance(props.kind, toRef(props, 'resource'), {
  pathwayId: props.pathwayId,
  onFlagAccepted: () => emit('flag-accepted'),
});

// Com todas as flags enviadas não há o que submeter
const allFlagsSent = computed(() => Number(props.resource.percentage) >= 100 || Boolean(props.resource.is_solved));

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["lp-card lab-env", { 'lab-env--compact': __props.compact }])
  }, [
    (__props.compact)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "header")
          ]),
          (_unref(isActive))
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(tl)('instance_active')), 1))
            : (!_unref(canStart))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: { name: 'profile-billing' },
                  class: "lp-btn",
                  title: _unref(tk)('only_subscribers_can_start_this_machine')
                }, {
                  default: _withCtx(() => [
                    _createVNode(HcIcon, {
                      name: "lock",
                      size: 15
                    }),
                    _createTextVNode(" " + _toDisplayString(_unref(tg)('common.subscribe')), 1)
                  ]),
                  _: 1
                }, 8, ["title"]))
              : (_unref(releaseCountdown))
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    _createTextVNode(_toDisplayString(_unref(tk)('release_in')) + " ", 1),
                    _createElementVNode("strong", _hoisted_5, _toDisplayString(_unref(releaseCountdown)), 1)
                  ]))
                : (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    type: "button",
                    class: "lp-btn",
                    disabled: _unref(loading),
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(start) && _unref(start)(...args)))
                  }, [
                    (_unref(loading))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7))
                      : (_openBlock(), _createBlock(HcIcon, {
                          key: 1,
                          name: "play-solid",
                          size: 15
                        })),
                    _createTextVNode(" " + _toDisplayString(_unref(tg)('challenge.start_an_instance')), 1)
                  ], 8, _hoisted_6))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("h3", null, _toDisplayString(_unref(tl)('environment')), 1),
          (_unref(isActive))
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(tl)('instance_active')), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(tl)('instance_idle')), 1))
        ])),
    (!__props.compact && !_unref(canStart))
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, [
            _createVNode(HcIcon, {
              name: "lock",
              size: 22
            })
          ]),
          _createElementVNode("p", null, _toDisplayString(_unref(tk)('only_subscribers_can_start_this_machine')), 1),
          _createVNode(_component_router_link, {
            to: { name: 'profile-billing' },
            class: "lp-btn"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(tg)('common.subscribe')) + " ", 1),
              _createVNode(HcIcon, {
                name: "arrow",
                size: 16
              })
            ]),
            _: 1
          })
        ]))
      : (!__props.compact && _unref(releaseCountdown))
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, [
              _createVNode(HcIcon, {
                name: "clock",
                size: 22
              })
            ]),
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_unref(tk)('release_in')) + " ", 1),
              _createElementVNode("strong", _hoisted_15, _toDisplayString(_unref(releaseCountdown)), 1)
            ])
          ]))
        : (!__props.compact && !_unref(isActive))
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, [
                _createVNode(HcIcon, {
                  name: "terminal",
                  size: 22
                })
              ]),
              _createElementVNode("p", null, _toDisplayString(_unref(tl)('start_hint')), 1),
              _createElementVNode("button", {
                type: "button",
                class: "lp-btn",
                disabled: _unref(loading),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(start) && _unref(start)(...args)))
              }, [
                (_unref(loading))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19))
                  : (_openBlock(), _createBlock(HcIcon, {
                      key: 1,
                      name: "play-solid",
                      size: 15
                    })),
                _createTextVNode(" " + _toDisplayString(_unref(tg)('challenge.start_an_instance')), 1)
              ], 8, _hoisted_18)
            ]))
          : (_unref(isActive))
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(tg)('common.ip_address')), 1),
                      _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(instance).ip_address), 1)
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "lab-env__icon-btn",
                      title: _unref(copied) ? _unref(tl)('copied') : _unref(tl)('copy'),
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(copyIp) && _unref(copyIp)(...args)))
                    }, [
                      _createVNode(HcIcon, {
                        name: _unref(copied) ? 'check' : 'copy',
                        size: 16
                      }, null, 8, ["name"])
                    ], 8, _hoisted_26)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(tk)('time_remaining')), 1),
                      _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(countdown) || '00:00:00'), 1)
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "lab-env__icon-btn lab-env__icon-btn--text",
                      title: _unref(tg)('challenge.add_another_1h'),
                      disabled: _unref(loading),
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(addTime) && _unref(addTime)(...args)))
                    }, [
                      _createVNode(HcIcon, {
                        name: "plus",
                        size: 15
                      }),
                      _hoisted_32
                    ], 8, _hoisted_31)
                  ])
                ]),
                (_unref(allFlagsSent))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createVNode(HcIcon, {
                        name: "check",
                        size: 18
                      }),
                      _createTextVNode(" " + _toDisplayString(_unref(tl)('all_flags_sent')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("form", {
                      key: 1,
                      class: "lab-env__flag",
                      onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_unref(submitFlag) && _unref(submitFlag)(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("label", _hoisted_34, [
                        _createVNode(HcIcon, {
                          name: "flag",
                          size: 18
                        }),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(flag) ? (flag).value = $event : null)),
                          type: "text",
                          name: "flag",
                          autocomplete: "off",
                          spellcheck: "false",
                          placeholder: "hackingclub{...}"
                        }, null, 512), [
                          [_vModelText, _unref(flag)]
                        ])
                      ]),
                      _createElementVNode("button", {
                        type: "submit",
                        class: "lp-btn",
                        disabled: _unref(submitting)
                      }, [
                        (_unref(submitting))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_36))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_unref(tl)('send_flag')) + " ", 1),
                        (!_unref(submitting))
                          ? (_openBlock(), _createBlock(HcIcon, {
                              key: 1,
                              name: "arrow",
                              size: 16
                            }))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_35)
                    ], 32)),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "lp-btn lp-btn--sm lp-btn--danger",
                    disabled: _unref(loading),
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(stop) && _unref(stop)(...args)))
                  }, [
                    (_unref(loading))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_39))
                      : (_openBlock(), _createBlock(HcIcon, {
                          key: 1,
                          name: "power",
                          size: 15
                        })),
                    _createTextVNode(" " + _toDisplayString(_unref(tk)('shutdown_instance')), 1)
                  ], 8, _hoisted_38)
                ])
              ]))
            : _createCommentVNode("", true)
  ], 2))
}
}

})